import React, {useEffect, useState} from "react";


const FormCampoCBX = ({label, valor, setValor, listaOptionsKV, com, isRequerido, isFlex=false, minWidth="", isNoLabel=false}) => {
  
  const [isValid, setIsValid] = useState(true);
  const [isActive, setIsActive] = useState(false);
  
  useEffect(() => {
    setIsActive(false);
  }, [])
  
  useEffect(() => {
    if (isRequerido) {
      setIsValid(!!valor);
    } else {
      setIsValid(true);
    }
    
  }, [isRequerido, valor])
  
  
  const cssLabel = isValid ? "label has-text-right label170" : "label has-text-right has-text-danger label170";
  
  const elemCom = com ? <small>{com}</small> : null;
  
  const iconRequerido = isRequerido ? "* " : " "
  
  const cssClass = "dropdown " + (isActive ? "is-active" : "");
  
  
  const listItem = listaOptionsKV.map((k, indexK) => {
    
    if (k === "sep") {
      return <hr key={indexK + 1} className="m0"/>
    }
    
    
    if (typeof k === "string") {
      
      const onClick = () => {
        setIsActive(false);
        setValor(k);
      }
      return (
        <span className="dropdown-item cursorPointer" key={indexK + 1} onClick={onClick}>
          {k}
        </span>
      );
      
    } else {
      
      const onClick = () => {
        setIsActive(false);
        setValor(k.key);
      }
      
      return (
        <span className="dropdown-item cursorPointer" key={indexK + 1} onClick={onClick}>
          {k.label}
        </span>
      );
    }
    
    
  });
  
  const isValue = typeof listaOptionsKV[0] === "string";
  
  const valorMostrado = isValue ? valor : listaOptionsKV.find(k => k.key === valor)?.label;
  
  
  const fieldBody = (<div className="field-body">
    <div className="field">
      <div className="control">
        
        <div className={cssClass} style={{width: "100%", minWidth}}>
          
          <div className="dropdown-trigger" style={{width: "100%"}}>
            <button
              className="button has-text-left"
              style={{justifyContent: "left", width: "100%"}}
              aria-haspopup="true" aria-controls="dropdown-menu3"
              onClick={() => setIsActive(!isActive)}
            >
              <span>{valorMostrado}</span>
              <span className="icon is-small">
                    <i className="fa fa-angle-down" aria-hidden="true"/>
                  </span>
            </button>
          </div>
          <div className="dropdown-menu" role="menu">
            <div className="dropdown-content" style={{maxHeight: "12em", overflowY: "scroll"}}>
              {listItem}
            </div>
          </div>
        </div>
        
        {elemCom}
      
      </div>
    </div>
  </div>);
  
  
  if (isFlex) {
    const elemLabel = isNoLabel
      ? null
      : <div className="m5R p5T"> {label} {iconRequerido}</div>;
    
    return (<div className="divFlex flexGrow1 p5R ">
      {elemLabel}
      {fieldBody}
    </div>);
  }
  
  const elemLabel = isNoLabel
    ? null
    : <div className="field-label is-normal "><label className={cssLabel}>{label} {iconRequerido}</label></div>
  
  return (
    <div className="field is-horizontal">
      {elemLabel}
      {fieldBody}
    
    </div>
  
  
  );
};

export default FormCampoCBX